<template>
  <div class="courier-info-component">
    <div class="icon-info">
      <font-awesome-icon icon="info-circle" />
    </div>
    <!-- Мобилка: полный состав списком, кнопка «Подробнее о заказе» уводила бы в редактор -->
    <template v-if="isMobileLayout">
      <basket-items-list
        class="mobile-basket-items"
        :items="basketItems"
      />
      <v-tooltip top max-width="300" :disabled="!cancelRestriction">
        <template v-slot:activator="{ on, attrs }">
          <span class="d-block" v-bind="attrs" v-on="on">
            <v-btn
              class="mobile-cancel-btn"
              color="red"
              :dark="!cancelRestriction"
              depressed
              block
              :disabled="!!cancelRestriction"
              @click="showDialog = true"
            >
              Отменить заказ
            </v-btn>
          </span>
        </template>
        {{ cancelRestriction }}
      </v-tooltip>
    </template>
    <div v-else class="order-info">
      <span v-if="showOrderInfo">
        {{ getOrderInfo }}
        <router-link
          class="order-info-link"
          :to="{
            path: '/fast-order',
            query: {
              id: this.order.id,
            },
          }"
        >Подробнее...</router-link>
      </span>
      <v-btn
        v-else
        color="#ff9100"
        dark
        @click="openFastOrder"
      >
        Подробнее о заказе
      </v-btn>
    </div>

    <v-select
      class="select select-more"
      placeholder="Опции"
      clearable
      solo
      no-data-text=""
      hide-details="auto"
      :menu-props="{ maxHeight: 'auto' }"
    >
      <template slot="no-data">
        <span></span>
      </template>
      <template slot="append-item">
        <div class="d-flex flex-column">
          <v-tooltip top max-width="300" :disabled="!cancelRestriction">
            <template v-slot:activator="{ on, attrs }">
              <span class="d-flex" v-bind="attrs" v-on="on">
                <v-btn
                  class="ma-2 flex-grow-1"
                  color="red"
                  depressed
                  :dark="!cancelRestriction"
                  :disabled="!!cancelRestriction"
                  @click="showDialog = true"
                >
                  Отменить заказ
                </v-btn>
              </span>
            </template>
            {{ cancelRestriction }}
          </v-tooltip>
          <v-btn
            v-if="isOrderInProgress && !isCallCentreStaff"
            class="ma-2"
            color="purple"
            dark
            depressed
            @click="changeStatus"
          >
            <template v-if="isReadySelfDeliveryOrder">
              {{ orderCompleteLabel }}
            </template>
            <template v-else>
              След. статус
            </template>
          </v-btn>

          <v-btn
            v-if="canChangePaymentType"
            class="ma-2"
            color="#ff9100"
            dark
            depressed
            @click="showChangePaymentDialog = true"
          >
            Сменить тип оплаты
          </v-btn>

          <v-btn
            v-if="canPay"
            class="ma-2"
            color="green"
            dark
            depressed
            @click="pay"
          >
            Оплатить
          </v-btn>

          <template v-if="isOrderInProgress && !isCallCentreStaff">
            <hr>

            <print-check-btn
              v-for="(item, key) in printButtonsList"
              :key="`print-btn-${key}`"
              :type="item.type"
              :order-id="order.id"
              :color="item.color"
            >
              {{ item.title }}
            </print-check-btn>
          </template>

          <!--          <print-check-btn type="main" :order-id="order.id" color="teal darken-3">
            Чек клиентский
          </print-check-btn>
          <print-check-btn
            type="kitchen-universal"
            :order-id="order.id"
            color="light-blue darken-4"
          >
            Чек для кухни
          </print-check-btn>-->

          <!--          <print-check-btn type="cold" :order-id="order.id" color="light-blue darken-4">
            Чек для кухни
          </print-check-btn>
          <print-check-btn type="hot" :order-id="order.id" color="pink darken-4">
            Чек для кухни
          </print-check-btn>-->
        </div>
      </template>
    </v-select>

    <!--    <div class="courier-info d-flex">
      <img v-if="hasCourierImage" class="courier-icon" :src="order.courier.image" alt="courier" />
      <img v-if="!hasCourierImage" class="courier-icon" src="/img/courier.png" alt="courier" />
      <span class="name d-flex flex-column">
        <span>Курьер</span>
        <span class="font-weight-medium">{{ getCourierName }}</span>
        <span class="font-weight-medium">{{ getCourierPhone }}</span>
      </span>
    </div>-->

    <!--    <v-btn
      v-if="isReadySelfDeliveryOrder "
      class="ma-2"
      color="success"
      dark
      depressed
      large
      @click="changeStatus"
    >
      Завершить заказ
    </v-btn>-->

    <!--    <large-btn
      v-if="isReadySelfDeliveryOrder"
      class="ma-2"
      color="success"
      height="60px"
      @click="changeStatus"
    >
      {{ orderCompleteLabel }}
    </large-btn>-->

    <courier-select
      v-if="canAssignCourier"
      v-model="order.courier"
      :order="order"
    />

    <!-- <div class="feedback-section"
    >
      -->
    <!--      <a class="feedback-button d-flex align-center" href="">-->
    <!--        <font-awesome-icon icon="headset" />-->
    <!--        <span class="font-weight-medium">Связаться с курьером</span>-->
    <!--      </a>-->
    <!--    </div>-->

    <promo-code-badge v-if="order.promoCode" class="promocode" :code="order.promoCode" />

    <!--    <v-btn @click="setAssemblyStatus" class="button-order-status" color="rgb(97, 78, 226)" dark>
      Начать сборку
    </v-btn>

    <v-btn @click="setReadyStatus" class="button-order-status" color="green" dark>
      Заказ собран
    </v-btn>-->

    <div class="close-button">
      <v-btn
        v-if="isMobileLayout"
        class="mobile-close-btn"
        color="#2e2e2e"
        dark
        depressed
        block
        @click="close"
      >
        <font-awesome-icon icon="times" class="mr-2" />
        Закрыть
      </v-btn>
      <button
        v-else
        class="button-close d-inline-flex align-center"
        @click="close"
      >
        <font-awesome-icon icon="times" />
        Закрыть
      </button>
    </div>

    <!-- Смена метода оплаты заказа -->
    <primary-confirm-dialog
      v-model="showChangePaymentDialog"
      :loading="changingPayment"
      :persistent="false"
      confirm-text="Изменить тип оплаты"
      @confirm="togglePaymentType()"
    >
      <template v-slot:title>
        Вы уверены что хотите изменить тип оплаты
        <!--        <br class="d-none d-md-inline" />-->
        заказа на
        <template v-if="targetPaymentTypeToChange === 'cash'">
          <b>"наличными"</b>
        </template>
        <template v-else-if="targetPaymentTypeToChange === 'terminal'">
          <b>"{{ terminalPaymentLabel }}"</b>
        </template>
        ?
      </template>
      <template v-if="canChangePaymentTypeAfterComplete" v-slot:subtitle>
        Заказ завершён: <!--<br />--> будут пересчитаны транзакции и баланс курьера,
        напечатаны фискальные чеки
      </template>
    </primary-confirm-dialog>

    <cancel-order-dialog
      v-model="showDialog"
      :order="order"
      :loading="canceling"
      @cancel="cancelOrder"
      @canceled="close"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import { cancelRestrictionReason } from '@/util/order-cancel'
  import { isTypeAcceptedFor } from '@/util/payment-mode'
  import PaymentType from '@/models/enums/PaymentType'
  import PaymentMode from '@/models/enums/PaymentMode'
  import OrderStatus from '@/models/enums/OrderStatus'
  import CourierSelect from '@/components/order-card/CourierSelect'
  import PrintCheckBtn from '@/components/order-card/PrintCheckBtn.vue'
  import DeliveryType from '@/models/enums/DeliveryType'
  import LargeBtn from '@/components/ui/buttons/LargeBtn.vue'
  import PaymentStatus from '@/models/enums/PaymentStatus'
  import editSessionApi from '@/api/order/edit-session'
  import paymentApi from '@/api/order/payment'
  import CheckType from '@/models/enums/cashbox/CheckType'
  import permissions from '@/mixins/permissions'
  import Role from '@/models/enums/Roles'
  import CRMPermission from '@/models/enums/permissions/CRMPermission'
  import BasketSource from '@/models/enums/BasketSource'
  import CancelOrderDialog from '@/components/order-processing/order-components/CancelOrderDialog.vue'
  import PrimaryConfirmDialog from '@/components/ui/dialogs/PrimaryConfirmDialog.vue'
  import BasketItemsList from '@/components/order-card/BasketItemsList.vue'

  export default {
    name: 'CourierInfo',
    components: { LargeBtn, PrintCheckBtn, CourierSelect, CancelOrderDialog, PrimaryConfirmDialog, BasketItemsList },
    mixins: [mixinSnackbarMessage, permissions],
    props: {
      order: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        showDialog: false,
        showChangePaymentDialog: false,
        canceling: false,
        changingPayment: false,
      }
    },
    computed: {
      ...mapGetters({
        orderCancelFlags: 'auth/orderCancelFlags',
      }),
      cancelRestriction () {
        return cancelRestrictionReason(this.order, this.orderCancelFlags)
      },
      // Граница совпадает с LESS-миксином .media-lg (@lg: 1024px) и с isMobile в OrderCard
      isMobileLayout () {
        return this.$vuetify.breakpoint.width <= 1024
      },
      basketItems () {
        return this.order?.basket?.items || []
      },
      // Колл-центр не двигает статусы и не печатает чеки - это работа ресторана.
      // userIs для супер-админа всегда true, поэтому его отсекаем явно
      isCallCentreStaff () {
        return !this.isSuperAdmin &&
          this.userIs([Role.CallCentreDirector, Role.CallCentreOperator])
      },
      printButtonsList () {
        let items = [
          {
            type: CheckType.ClientCheck,
            title: 'Чек клиентский',
            color: 'teal darken-3',
          },
          {
            type: CheckType.MenuItemsComposition,
            title: 'Чек маркировки (состав)',
            color: 'teal darken-3',
          },
          {
            type: CheckType.KitchenCheck,
            title: 'Чек для кухни',
            color: 'light-blue darken-4',
          },
          {
            type: CheckType.FiscalSellCheck,
            title: 'Фискальный чек',
            color: '',
          },
        ]

        if (this.userIs(Role.SuperAdmin)) {
          items = items.concat([
            /* {
              type: CheckType.FiscalRefundCheck,
              title: 'Чек отмены',
              color: 'purple',
            }, */
            {
              type: CheckType.KitchenCancelCheck,
              title: 'Чек отмены кухни',
              color: 'purple',
            },
          ])
        }
        return items
      },
      terminalPaymentLabel () {
        return `${PaymentType.getName(PaymentType.Terminal, this.order?.deliveryType, PaymentMode.ofOrder(this.order))} (терминал)`.toLowerCase()
      },
      isOrderPaid () {
        return this.order?.payment?.status === PaymentStatus.Success
      },
      isOrderInProgress () {
        return (
      this.order?.orderStatus !== OrderStatus.Completed &&
      this.order?.orderStatus !== OrderStatus.Canceled
        )
      },
      isReadySelfDeliveryOrder () {
        return (
          this.isSelfDeliveryOrder &&
          this.order.orderStatus === OrderStatus.ReadyForIssue
        )
      },
      isSelfDeliveryOrder () {
        return this.order?.deliveryType === DeliveryType.Self
      },
      canAssignCourier () {
        return this.order?.deliveryType === DeliveryType.Delivery
      },
      canChangePaymentType () {
        return (
          this.canChangePaymentTypeInProgress ||
          this.canChangePaymentTypeAfterComplete
        )
      },
      canChangePaymentTypeInProgress () {
        return (
          !this.isOrderPaid &&
          this.isTargetPaymentTypeAvailable &&
          this.isOrderInProgress &&
          (this.order.paymentType === PaymentType.Terminal ||
            this.order.paymentType === PaymentType.Cash)
        )
      },
      // Завершённый заказ доставки: не агрегатор, не онлайн, cash/terminal, право на редактирование.
      // Закрытость кассы валидирует бэк - при ошибке покажем снекбар.
      canChangePaymentTypeAfterComplete () {
        return (
      this.order?.orderStatus === OrderStatus.Completed &&
      this.order?.deliveryType === DeliveryType.Delivery &&
          !this.isAggregatorOrder &&
          !this.isOrderPaid &&
          this.isTargetPaymentTypeAvailable &&
          (this.order.paymentType === PaymentType.Terminal ||
            this.order.paymentType === PaymentType.Cash) &&
          this.userCan(CRMPermission.ChangeCompletedOrderPayment)
        )
      },
      isAggregatorOrder () {
        return BasketSource.getAggregatorsSources().includes(
      this.order?.basket?.basketSource,
        )
      },
      canPay () {
        return (
          this.userCan(CRMPermission.MakeOrderPayment) &&
          !this.isOrderPaid &&
          this.isSelfDeliveryOrder &&
          !OrderStatus.prohibitingItemsEditingStatuses.includes(
        this.order?.orderStatus,
          )
        )
      },
      // пустой/отсутствующий список = настройка не задана, ведём себя как раньше (та же семантика, что на бэке)
      isTargetPaymentTypeAvailable () {
        const target = this.targetPaymentTypeToChange
        const available = this.order?.basket?.availablePaymentTypes
        if (available?.length && !available.includes(target)) {
          return false
        }
        // общий CRM-набор включает и методы точки, поэтому целевой тип сверяем с режимом платежа:
        // доставке «оплата курьеру» нельзя выставить терминал, которого у курьера нет
        const mode = PaymentMode.ofOrder(this.order)
        return !mode || isTypeAcceptedFor(this.order?.basket || {}, mode, target)
      },
      targetPaymentTypeToChange () {
        if (this.order.paymentType === PaymentType.Terminal) {
          return PaymentType.Cash
        } else if (this.order.paymentType === PaymentType.Cash) {
          return PaymentType.Terminal
        } else {
          return 'error' // Для предотвращения ошибочной смены типа оплаты
        }
      },
      hasCourierImage () {
        return !!this.order.courier && !!this.order.courier.image
      },
      getCourierName () {
        if (this.order.basket.basketSource === 'deliveryСlub') {
          return 'Delivery Club'
        }

        if (this.order.basket.basketSource === 'yandex') {
          return 'Яндекс.Еда'
        }

        return this.order.courier ? this.order.courier.name : 'Не назначен'
      },
      getCourierPhone () {
        return this.order.courier ? this.order.courier.phone : ''
      },
      getOrderInfo () {
        return this.order.info ? this.order.info.fullName : '–'
      },
      showOrderInfo () {
        return this.getOrderInfo?.length < 170
      },
      orderCompleteLabel () {
        return this.order.payment?.status === PaymentStatus.Success
      ? 'Завершить заказ'
      : 'Оплатить и завершить'
      },
    },
    methods: {
      togglePaymentType () {
        if (!this.canChangePaymentType) {
          this.showErrorMessage(
            'Нельзя изменить тип оплаты у выбранного заказа...',
          )
          this.showChangePaymentDialog = false
          return false
        }

        if (this.canChangePaymentTypeAfterComplete) {
          return this.changeCompletedOrderPayment()
        }

        const id = this.order.basket.id
        const data = {
          paymentType: this.targetPaymentTypeToChange,
        }

        this.$store
          .dispatch('baskets/updateBasketPayment', { data, id })
          .then((res) => {
            if (res.status === 200) {
              this.showSuccessMessage('Тип оплаты изменен!')
              this.showChangePaymentDialog = false
              this.close()
            } else {
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
      async changeCompletedOrderPayment () {
        this.changingPayment = true
        try {
          const response = await paymentApi.changeCompleted(
            this.order.id,
            this.targetPaymentTypeToChange,
          )
          this.$store.commit('orders/replaceOrderInList', {
            id: response.data.id,
            data: response.data,
          })
          this.showSuccessMessage('Тип оплаты изменен!')
          this.showChangePaymentDialog = false
          this.close()
        } catch (e) {
          this.showErrorFromResponse(e)
        } finally {
          this.changingPayment = false
        }
      },
      cancelOrder () {
        this.canceling = true
        this.$store.dispatch('orders/cancelOrder', this.order.id).then((res) => {
          if (res.status === 200) {
            this.showDialog = false
            this.close()
          } else {
            this.showErrorMessage(res.response.data.message)
          }
        }).catch((e) => {
          this.showErrorFromResponse(e)
        }).finally(() => {
          this.canceling = false
        })
      },
      setAssemblyStatus () {
        this.$emit('setAssemblyStatus', this.order.id)
        this.close()
      },
      setReadyStatus () {
        this.$emit('setReadyStatus', this.order.id)
        this.close()
      },
      changeStatus () {
        this.isReadySelfDeliveryOrder && !this.isOrderPaid
          ? this.pay()
          : this.$emit('changeStatus', this.order.id)

        this.close()
      },
      close () {
        this.$emit('close')
      },
      openFastOrder () {
        editSessionApi.open(this.order.id)
        this.$router.push({
          path: '/fast-order',
          query: {
            id: this.order.id,
          },
        })
      },
      pay () {
        this.$store.commit('orders/setCurrentEditOrder', this.order)
        this.$store.commit('baskets/setBasket', this.order.basket)
        this.$store.commit('orders/setShowPaymentDialog', true)
      },
    },
  }
</script>

<style lang="less" scoped>
//noinspection LessResolvedByNameOnly
.courier-info-component {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(#000000, 0.9);
  padding-left: 8px;
  padding-right: 31px;
  z-index: 11;

  // Рамка и скругление - в PromoCodeBadge, здесь только размер, цвет и место
  .promocode {
    height: 38px;
    padding: 0 17px;
    margin-right: 5px;
    font-size: 18px;
    color: #ffffff;
  }

  .icon-info {
    width: 50px;
    height: 50px;

    svg {
      width: 100%;
      height: 100%;
      .fill-svg(#FFFFFF);
    }
  }

  .order-info {
    max-width: 360px;
    width: 100%;
    color: #ffffff;
    margin-right: 10px;

    &-link {
      margin-left: 15px;
    }
  }

  .courier-info {
    margin-right: 20px;
    max-width: 200px;

    .courier-icon {
      margin-right: 19px;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      flex-shrink: 0;
      object-fit: cover;
    }

    .name {
      color: #ffffff;
    }
  }

  .feedback-section {
    .feedback-button {
      border-radius: 100px;
      border: 1px solid #ffffff;
      text-decoration: none;
      color: #ffffff;
      font-size: 16px;
      line-height: 19px;
      padding: 13px 17px;

      svg {
        margin-right: 17px;
        width: 24px;
        height: 24px;
      }
    }
  }

  .close-button {
    margin-left: 20px;
    svg {
      width: 19px;
      height: 19px;
      .fill-svg(#FFFFFF);
      margin-right: 7px;
    }

    .button-close {
      padding: 10px 0;
      color: #ffffff;
      font-size: 17px;
      line-height: 1;
    }
  }

  .select {
    &.select-more {
      max-width: 150px;
    }
    ::v-deep {
      .v-input__control {
        min-height: 41px;
      }
    }
  }

  .select-check-section {
    max-width: 200px;
    width: 100%;
  }

  .media-lg({
      padding: 15px 10px;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      // Под шторкой просвечивала карточка и состав не читался
      background-color: #1c1c1c;
      overflow-y: auto;

      .icon-info {
        display: none;
      }

      .order-info {
        margin-bottom: 15px;
      }

      .mobile-basket-items {
        margin-bottom: 16px;
      }

      // Vuetify даёт .v-btn--block flex: 1 0 auto, а шторка на мобилке -
      // колоночный флекс: без сброса кнопка растягивается на всю высоту
      .mobile-cancel-btn {
        flex: 0 0 auto;
        align-self: stretch;
        margin-bottom: 20px;
      }

      .select.select-more {
        display: none;
        max-width: 100%;
        width: 100%;
        flex: 0;
        margin-bottom: 15px;
      }

      .courier-info {
        margin-right: 0;
        margin-bottom: 20px;
      }

      .button-order-status {
        display: none;
        margin-bottom: 10px;
        width: 100%;
      }

      .close-button {
        // 50px от блока курьера: у CourierSelect своих вертикальных отступов нет
        margin-top: 50px;
        margin-left: 0;
        align-self: stretch;
        width: 100%;
      }

      // flex сбрасываем: у .v-btn--block он 1 0 auto, а шторка - колоночный флекс
      .mobile-close-btn {
        flex: 0 0 auto;
        width: 100%;
        height: 48px;
        border-radius: 10px;
        font-size: 15px;
        font-weight: 500;
        letter-spacing: normal;
        text-transform: none;

        svg {
          width: 16px;
          height: 16px;
          margin-right: 0;
        }
      }
    });
}
</style>
